import React from "react";
import { NavLink } from "react-router-dom";
import aboutImage from "../../assets/images/appImages/about-image.png"; // votre image

const AboutSection: React.FC = () => {
  return (
    <section className="section-about-homepage ">
      <div className="container-about">

        <h2 className="title-about text-center">Pure Essence Botanicals</h2>

        <div className="row-about">

          {/* Image gauche */}
          <div className="col-img-about">
            <img
              src={aboutImage}
              alt="Femme appliquant de l'huile capillaire"
              className="img-about"
              loading="lazy"
            />
          </div>

          {/* Texte droite */}
          <div className="col-text-about">
            <p className="text-about">
              Chez <span>PURE ESSENCE</span>, nous sommes engagés dans une démarche globale
              qui relie la terre, la transformation et le bien-être au quotidien.
              Entreprise sénégalaise ancrée dans ses valeurs, nous développons une
              activité intégrée allant de la production agricole à la transformation
              de produits finis, avec une volonté forte : valoriser les ressources
              locales tout en proposant des solutions saines, efficaces et accessibles.
            </p>
            <NavLink className="btn-about-home" to="/a-propos-de-nous">
              En savoir plus
            </NavLink>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutSection;